export const getters = {
    list: state => state.list,
    structure:state=>state.structure ,
    staff_list: state=>state.staff_list,
    mockdata: state=>state.mockdata
  };
  